import React, {useState, useEffect} from 'react';
import {Card, Button, message, Space} from 'antd';
import AddNewRequest from "../Request/AddNewRequest";
import {PlusOutlined, RedoOutlined} from "@ant-design/icons";
import {orderBy} from 'lodash';
import RequestListView from './RequestListView';
import {getTrnslationRequets} from "../../services/api.service";

const RequestsList = () => {
    const [modalState, setModalState] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [tblLoader, setTableLoader] = useState(false);

    const newRequestModal = (state, data) => {
        setModalState(state);
        if (data && data.length) {
            const allRequests = [...data, ...tableData];
            // allRequests.unshift(data);
            setTableData(allRequests)
        }
    };

    useEffect(() => {
        getRequests();
    }, []);

    const getRequests = async () => {
        try {
            setTableLoader(true);
            const {data} = await getTrnslationRequets();
            if (data.error) {
                message.error('Failed to fetch requests list');
                setTableLoader(false)
            } else {
                const sortedData = orderBy(data.data, ['createdAt'], ['desc']);
                setTableData([...sortedData]);
                setTableLoader(false)
            }
        } catch (err) {
            setTableLoader(false)
        }
    };

    return (
        <React.Fragment>
            <Card title="Translation Data"
                  extra={
                      (
                          <React.Fragment>
                              <Space>
                                  <Button onClick={() => getRequests()} icon={<RedoOutlined />} type="default">Refresh</Button>
                                  <Button onClick={() => newRequestModal(true)} icon={<PlusOutlined/>} type="primary">Add New</Button>
                              </Space>
                          </React.Fragment>
                      )
                  }>
                <RequestListView tableData={tableData} tblLoader={tblLoader}/>
                {modalState && (<AddNewRequest state={modalState} togelState={newRequestModal}/>)}
            </Card>
        </React.Fragment>
    )
};

export default RequestsList;